import { differenceInCalendarDays } from 'date-fns';
import { VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { useFormatDate, useFormatDistance } from '@/hooks/date';
import { cn } from '@/lib/cn';
type DateDurationCellProps = {
  date: Date;
  urgentWithinDays?: number;
};
export function DateDurationCell({
  date,
  urgentWithinDays
}: DateDurationCellProps) {
  const formatDate = useFormatDate();
  const formatDistance = useFormatDistance();
  const now = new Date();
  const daysRemaining = differenceInCalendarDays(date, now);
  const isUrgent = urgentWithinDays != null && daysRemaining <= urgentWithinDays;
  return <VStack className="gap-0.5">
      <Text variant="label" className="text-neutral-on-fill">
        {formatDate(date, {
        preset: 'date'
      })}
      </Text>
      <Text variant="labelSmallReg" className={cn(isUrgent ? 'text-error-on-neutral-fill' : 'text-neutral-muted-on-fill')}>
        {formatDistance(date, now)}
      </Text>
    </VStack>;
}